<template>
  <v-app id="inspire">
    <navigation-drawer class="navigation-drawer"></navigation-drawer>
    <v-app-bar app clipped-left v-show="loggedIn">
      <v-app-bar-nav-icon
        @click.stop="() => toggleDrawer(!drawer)"
      ></v-app-bar-nav-icon>
      <v-toolbar-title>Sar Express</v-toolbar-title>
      <v-spacer></v-spacer>
      Salir
      <v-btn icon @click="DO_LOGOUT">
        <v-icon>mdi-export</v-icon>
      </v-btn>
    </v-app-bar>

    <v-main>
      <v-container>
        <router-view></router-view>
        <div v-if="loading">
          <loader-dots
            :color="'#c1c1c1'"
            :background="'#121212'"
            :duration="1"
            :size="15"
          />
        </div>
      </v-container>
    </v-main>

    <v-footer app>
      <span>&copy; {{ new Date().getFullYear() }}</span>
    </v-footer>
  </v-app>
</template>

<script>
import { mapMutations, mapActions, mapState } from "vuex";
import NavigationDrawer from "./layout/NavigationDrawer.vue";
import loaderDots from "@nulldreams/vue-loading/src/components/dots";

export default {
  data: () => ({ showBar: false }),
  components: {
    NavigationDrawer,
    loaderDots,
  },

  computed: {
    ...mapState("auth", ["drawer", "loggedIn", "loading"]),
  },

  methods: {
    ...mapMutations("auth", ["toggleDrawer"]),
    ...mapActions("auth", ["DO_LOGOUT"]),
  },
};
</script>

<style>
</style>

<style lang="scss">
.navigation-drawer {
  z-index: 10000;
}
</style>
